import { Connection } from '../../../connections/connection.class';
import { ReferenceMap } from '../../../public.types';

type IsIslandPassthroughRequiredParams = {
	refMap: ReferenceMap;
	connection: Connection;
};

export const isIslandPassthroughRequired = ({ connection, refMap }: IsIslandPassthroughRequiredParams): boolean => {
	const sourceConnection = connection.sourcePanel;
	const targetConnection = connection.targetPanel;

	const required: boolean = (sourceConnection !== null && targetConnection !== null) && (connection.padding <= 1);

	// console.log('rule:isIslandPassthroughRequired', required, {
	// 	source: sourceConnection?.hasPassthrough,
	// 	target: targetConnection?.hasPassthrough
	// });

	return required;
};
